import { z } from 'zod'

export const insulationPreparationSectionSchema = z.object({
  id: z.string(),
  type: z.literal('insulation_preparation'),
  title: z.string(),
  field: z.string(),
  sourceZonesField: z.string(),
  strategiesContextKey: z.string(),
})
export type InsulationPreparationSection = z.infer<
  typeof insulationPreparationSectionSchema
>

export const insulationPreparationSchema = z.object({
  sourceZoneId: z.string(),
  insulated: z.boolean().optional(),
  plannedRemovalAreaM2: z.number().nonnegative().optional(),
})
export type InsulationPreparation = z.infer<typeof insulationPreparationSchema>
